// The phone's doors from My Team (DIRECTION U20 and U21, B-316): what sits
// beside the lineup from a tablet up is a screen of its own on a phone, one
// tap from the roster. A phone shows one thing at a time, so the work there is
// getting around. Waivers and Trades carry the count of what waits on me.

import { useLeagueBase } from '../../data/hooks';
import { useLeagueSource } from '../../data/leagueSource';
import { Button, Count } from '../../kit/ui';
import type { IconName } from '../../kit/Icon';

export function TeamDoors({ claims, offers }: { claims: number; offers: number }) {
  const base = useLeagueBase();
  // Plan ahead reads a real league's schedule; the tour plays one week.
  const real = useLeagueSource() === 'api';
  const doors: { to: string; label: string; icon: IconName; count?: number }[] = [
    { to: `${base}/players`, label: 'Players', icon: 'search' },
    { to: `${base}/waivers`, label: 'Waivers', icon: 'waivers', count: claims },
    { to: `${base}/trades`, label: 'Trades', icon: 'trade', count: offers },
    ...(real ? [{ to: `${base}/plan`, label: 'Plan ahead', icon: 'when' as const }] : []),
    { to: `${base}/news`, label: 'News', icon: 'news' },
  ];
  return (
    <nav className="fsp-team-doors" aria-label="Manage your team">
      {doors.map((d) => (
        <Button key={d.to} size="xs" variant="secondary" icon={d.icon} to={d.to}>
          {d.label}
          {d.count ? (
            <>
              {' '}
              <Count value={d.count} tone="warn" />
            </>
          ) : null}
        </Button>
      ))}
    </nav>
  );
}
